<template lang="pug">
  .res
    .title {{$t('reservation.res4.title')}}
    .content
      res-confirm
    .bottom
      .btn-next(@click="onSubmit") {{$t('btn.resNow')}}
      .btn-copy
        span 点击立即预约, 即表示已阅读并同意
        span(@click="onNotice").cl-blue 《支付宝空间站服务须知》
    popup-notice(v-if="showNotice" @close="showNotice=false")
    charity-popup(v-if="showCharityPopup")

  
</template>
<script>
import AlipayService from '@/services/AlipayService'
import { mapState, mapMutations, mapActions } from 'vuex'
import ResConfirm from '@/components/res/ResConfirm'
import PopupNotice from '@/components/wedgits/PopupNotice'
import CharityPopup from '@/components/wedgits/CharityPopup'
export default {
  name: 'Res4',
  components: { CharityPopup, PopupNotice, ResConfirm },
  props: {},
  data() {
    return {
      res: null,
      showNotice: false,
    }
  },

  computed: {
    ...mapState('app', ['ticketPicked', 'schedulePicked', 'showCharityPopup']),
  },
  methods: {
    ...mapMutations('app', ['setRouterBack', 'setRouterLast', 'setPending']),
    ...mapActions('app', ['ResAbort']),
    onSubmit() {
      if (this.res) {
        this.onSubmitted()
      } else {
        this.resSubmit()
      }
    },
    onSubmitted() {
      if (this.res.payRequired === 0) {
        this.onSuccess()
      } else if (this.res.tradeNo) {
        this.payRequest()
      }
    },
    onMessage(e) {
      if (e.msg === AlipayService.Events.RES_SUBMITTED) {
        console.log('res submitted!!!', e)
        this.res = e.data.res
        //强制设置不需要支付
        // this.res.payRequired = 0
        if (this.res) {
          this.setPending(false)
          this.onSubmitted()
        }
      }
      if (e.msg === AlipayService.Events.PAY_SUCCESS) {
        //this.setPending(false)
        this.onSuccess()
      }
    },
    onSuccess() {
      setTimeout(() => {
        this.setRouterBack('/')
        this.$router.replace(`/reservation/res5?resId=${this.res.resId}`)
      }, 200)
    },
    resSubmit() {
      let res = {
        ticketId: this.ticketPicked.id,
        scheduleId: this.schedulePicked.id,
      }
      console.log(res)
      AlipayService.sendEvent(AlipayService.Events.RES_SUBMIT, res)
      AlipayService.on(AlipayService.Events.ONMESSAGE, this.onMessage)
      //this.$router.replace('/reservation/res5')
      this.setPending(true)
    },
    payRequest() {
      //this.setPending(true)
      AlipayService.sendEvent(
        AlipayService.Events.PAY_REQUEST,
        this.res.tradeNo
      )
    },
    onNotice() {
      this.showNotice = true
    },
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    console.log(to, from)
    if (to.path !== '/reservation/res5') {
      if (this.res && this.res.resId) {
        console.log('!!!!!!!!!!!!!Abort')
        this.ResAbort(this.res.resId)
        this.res = null
      }
    }
    next()
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
@import "src/styles/res.sass"
</style>
